import { Navigate, useLocation } from "react-router-dom";
import {
  enforceOrgAdminBranchPolicy,
  getActiveBranchId,
  shouldShowOrgAdminBranchUI,
} from "../utils/branchSession";

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("token"); // or use Context/Redux
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace />; // redirect to login if not authenticated
  }

  enforceOrgAdminBranchPolicy();

  // Branch gate: an org admin with branches (branch_avail) MUST pick a branch
  // before using the app. Until an active branch is chosen, force them onto the
  // branch-selection page — except when they're already there. This wraps every
  // app route, so it can't be bypassed by typing a URL directly.
  if (shouldShowOrgAdminBranchUI() && !getActiveBranchId() && location.pathname !== "/branches") {
    return <Navigate to="/branches" replace />;
  }

  if (!shouldShowOrgAdminBranchUI() && location.pathname === "/branches") {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;
